import { Emitter } from 'pixi-particles';

const update = Emitter.prototype.update;

Emitter.prototype.update = function (delta) {
  // @ts-ignore
  if (this._parent && this._parent._destroyed) return;
  update.call(this, delta);
};
